import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";

function AppDropdown() {
  return (
    <Dropdown className="mx-3">
      <Dropdown.Toggle variant="success" id="dropdown-basic">
        Menu Dropdown
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item as={Link} to="/">
          Home
        </Dropdown.Item>
        <Dropdown.Item as={Link} to="/converter">
          Converter
        </Dropdown.Item>
        <Dropdown.Item as={Link} to="/game">
          Game
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default AppDropdown;
